module.exports = __webpack_public_path__ + "static/media/fabbrica-milano-cover.3b1fdb56.svg";